import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran11() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "11");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 11" title="The Vow">
        <YouTubeEmbed videoId="GWaTI0AINMc" title="The Vow — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/11-the-vow.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="C major in 6/8 — the F/G moment">
        {/* Chorus from Jason's chart: C | C G/B | Am | Am Gm7 | F | C | F | F/G */}
        <RomanNumeralAnalysis
          label="Chorus"
          caption="C → G/B → Am → Gm7 → F → C → F → F/G. Gm7 brings in B♭, a note from outside C major, and leads smoothly into F."
          chords={[
            { chord: "C",   rn: "I",   function: "Tonic",        pitches: ["C3","E3","G3","C4"] },
            { bar: true },
            { chord: "C",   rn: "I",   function: "Tonic",        pitches: ["C3","E3","G3","C4"] },
            { chord: "G/B", rn: "V⁶",  function: "Dominant",     pitches: ["B2","D3","G3","B3"] },
            { bar: true },
            { chord: "Am",  rn: "vi",  function: "Submediant",   pitches: ["A2","C3","E3","A3"] },
            { bar: true },
            { chord: "Am",  rn: "vi",  function: "Submediant",   pitches: ["A2","C3","E3","A3"] },
            { chord: "Gm7", rn: "v7",  function: "Borrowed",     pitches: ["G2","D3","F3","Bb3"] },
            { bar: true },
            { chord: "F",   rn: "IV",  function: "Pre-dominant", pitches: ["F2","A2","C3","F3"] },
            { bar: true },
            { chord: "C",   rn: "I",   function: "Tonic",        pitches: ["C3","E3","G3","C4"] },
            { bar: true },
            { chord: "F",   rn: "IV",  function: "Pre-dominant", pitches: ["F2","A2","C3","F3"] },
            { bar: true },
            { chord: "F/G", rn: "V11", function: "Dominant",     pitches: ["G2","F3","A3","C4"] },
          ]}
        />
        <KeyIdea title="What F/G does">
          F/G is an F major chord with G in the bass: G–F–A–C. Theory books often call it V11 — a
          G chord with its 7th (F), 9th (A) and 11th (C) but no 3rd. Without the B it does not pull
          home to C as hard as G7 does, so it hovers. It is the last chord of the chorus.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="IV over V">
        <DidYouKnow title="IV over V">
          F/G is often described as "IV over V" — the IV chord sitting on the 5th of the key in the
          bass. It is a familiar sound in gospel, soul and pop ballads: almost home, but not yet.
        </DidYouKnow>
      </Section>
    </LessonShell>
  );
}
